// Imports de módulos
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Imports de directivas
import { BtnLoadingDirective } from './Directives/btn-loading.directive';
import { SafeHtmlPipe } from './Pipes/sanitize.pipe'
// Imports de tus módulos personalizados
import { MATERIAL_MODULES } from './material.config'; // El array que creamos antes
import { FORMS_IMPORTS } from './forms.config';
// import { MODAL_WINDOW_IMPORTS } from './modal-window/modal-window.config'; // Este sigue siendo un módulo tradicional

// Array con las directivas/componentes/pipes compartidos
export const SHARED_DECLARATIONS = [
  BtnLoadingDirective,
  SafeHtmlPipe
];

// Array con TODO lo que necesitas importar en componentes
export const SHARED_IMPORTS = [
  // Módulos de Angular
  CommonModule,
  RouterModule,
  ...FORMS_IMPORTS,
  ...MATERIAL_MODULES,
  // ...MODAL_WINDOW_IMPORTS,
];



// export const SHARED_MODAL_WINDOW = [
//   // Módulos de Angular
//   CommonModule,
//   ...MODAL_WINDOW_IMPORTS,
// ];
